import { useFormikContext } from 'formik';
import React from 'react'

export default function HomeTextArea({label, name, placeholder, disabled, rows}) {
    const {
        handleChange,
        errors,
        touched,
        setFieldTouched,
        values,
      } = useFormikContext();

  return (
    <div className="my-3 col-span-2">
        <label className="block text-d text-sm mb-2 capitalize" for="bio">
           {label||name}
        </label>
        <textarea
            disabled={disabled} 
            name={name} 
            onBlur={() => {
                setFieldTouched(name);
            }}
            placeholder={placeholder}
            value={values[name]}
            onChange={handleChange} 
            rows={rows||"2"} className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 
            leading-tight focus:outline-none focus:shadow-outline" 
        ></textarea>
        {touched[name] && errors[name] && (
          <div className='text-red-400' style={{fontSize: ".8rem" }}>{errors[name]}</div>
        )}
    </div>
  )
}